import { render, staticRenderFns } from "./ServiceValueEdit.vue?vue&type=template&id=c8aa6522"
import script from "./ServiceValueEdit.vue?vue&type=script&lang=js"
export * from "./ServiceValueEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports